import { Alert } from 'antd'
import { menuBuilderGpReviewCopy as copy } from 'src/constants/menuBuilderCopy'

const RecipeEconomicsStaleBanner = ({ staleCount = 0 }) => {
  if (!staleCount) {
    return null
  }

  const description =
    staleCount === 1
      ? copy.staleEconomicsListSingular
      : copy.staleEconomicsListPlural.replace('{count}', String(staleCount))

  return (
    <Alert
      type='info'
      showIcon
      style={{ margin: '0 5px 10px' }}
      message={copy.staleEconomicsListTitle}
      description={description}
    />
  )
}

export default RecipeEconomicsStaleBanner
